import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { CreditNullStateButtonRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { CreditNullStateButtonResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const creditNullStateButton = (request: CreditNullStateButtonRequest, options?: CashRequestOptions) =>
  post<CreditNullStateButtonRequest, CreditNullStateButtonResponse>('/2.0/cash/credit-null-state-button', request, {
    ...options,
    rejectOnError: true,
  })
